import { combineReducers } from "redux";
import { withResetState } from "../../../wrapperReducer";
import commonReducer from "../../commonReducer/commonReducer";
import drivingMarketParamsReducer, { initCircuitState } from "../common/params";
import upperLowerCircuit from "./upperLowerCircuit";
export default combineReducers({
    reducersData: upperLowerCircuit,
    commonData: commonReducer,
    paramsData: withResetState(initCircuitState)(drivingMarketParamsReducer),
});
